import {
  GET_FORM_CONFIG,
  GET_CONSIGNER_LIST,
  GET_START_ADDRESS,
  GET_END_ADDRESS,
  CREATE_DEMAND,
  ADD_ADDRESS,
  GET_VIA_POINTS_SUGGESTIONS,
} from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  consignerList: { consigners: [] },
  startAddresses: [],
  endAddresses: [],
  formConfig: {},
  demandCreated: false,
  createDemandErrorMessage: '',
  viaPointsList: [],
  addressAdded: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_FORM_CONFIG[REQUEST]:
      return { ...state, demandCreated:false,addressAdded:false };
    case GET_FORM_CONFIG[SUCCESS]:
      return { ...state, formConfig: action.response };
    case GET_CONSIGNER_LIST[REQUEST]:
      return { ...state };
    case GET_CONSIGNER_LIST[SUCCESS]:
      return { ...state, consignerList: action.response };
    case GET_START_ADDRESS[REQUEST]:
      return { ...state };
    case GET_START_ADDRESS[SUCCESS]:
      return { ...state, startAddresses: action.response };

    case GET_END_ADDRESS[REQUEST]:
      return { ...state };
    case GET_END_ADDRESS[SUCCESS]:
      return { ...state, endAddresses: action.response };

    case GET_VIA_POINTS_SUGGESTIONS[REQUEST]:
      return { ...state, viaPointsList: [] };
    case GET_VIA_POINTS_SUGGESTIONS[SUCCESS]:
      return { ...state, viaPointsList: action.response };

    case CREATE_DEMAND[REQUEST]:
      return { ...state, createDemandErrorMessage: '', demandCreated: false };
    case CREATE_DEMAND[SUCCESS]:
      return { ...state, createDemandErrorMessage: '', demandCreated: true };
    case CREATE_DEMAND[FAILURE]:
      return { ...state, createDemandErrorMessage: action.response.message };
    case ADD_ADDRESS[REQUEST]:
      return { ...state, addressAdded: false };
    case ADD_ADDRESS[SUCCESS]:
      return { ...state, addressAdded: true };
    default:
      return state;
  }
}

export const getConsignerList = (state) => state.createDemand.consignerList;
export const getStartAddressList = (state) => state.createDemand.startAddresses;
export const getEndAddressList = (state) => state.createDemand.endAddresses;
export const getFormConfig = (state) => state.createDemand.formConfig;
export const getcreateDemandReducer = (state) => state.createDemand;
export const getCreateDemandErrorMsg = (state) => state.createDemand.createDemandErrorMessage;
